<ng-container appFormRegistration [parentForm]="form">
  @if (formData.saveError) {
    <div class="alert alert-danger mb-3" role="alert">
      {{ formData.saveError }}
    </div>
  }
        <h5 class="form-section-title">รายละเอียดข้อมูลธุรกิจ (สำหรับนิติบุคคล)</h5>

        <div class="row g-3 mb-3">
          <div class="col-xl-7">
            <label class="form-label" for="registrationNumber">เลขทะเบียนนิติบุคคล</label>
            <div class="d-flex gap-2 align-items-center">
              <input type="text"
                     class="form-control form-control-sm"
                     id="registrationNumber" name="taxId"
                     [(ngModel)]="formData.model.taxId"
                     [disabled]="formData.isSearchingCompany"
                     placeholder="ระบุเลขทะเบียนนิติบุคคล 13 หลัก">
              <button class="btn btn-sm btn-primary d-inline-flex justify-content-center align-items-center gap-1"
                      type="button"
                      [disabled]="formData.isSearchingCompany"
                      (click)="formData.searchCompany()">
                @if (formData.isSearchingCompany) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span>กำลังค้นหา...</span>
                } @else {
                  <span>ค้นหา</span>
                }
              </button>
            </div>
          </div>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-12">
            <div class="d-flex align-items-center gap-2">
              <label class="form-label mb-0">
                ใบรับรองที่ใช้กับธุรกิจนี้
                @if (formData.certificateOptional) {<span class="text-secondary small fw-normal">(ไม่บังคับสำหรับประเภทที่เลือก)</span>} @else {<span class="text-danger">*</span> <span class="requirement-note">บังคับเพราะเลือก {{ formData.certificateRequiredNote }}</span>}
              </label>
              <app-certificate-sync-button [taxId]="formData.model.taxId"
                                           (synced)="formData.onCertificatesSynced()"></app-certificate-sync-button>
              <app-certificate-add-button [taxId]="formData.model.taxId"
                                          [ownerName]="formData.model.title"
                                          (added)="formData.onCertificateAdded($event)"></app-certificate-add-button>
            </div>
            <input type="hidden" name="certificateNos" [ngModel]="formData.selectedCertificateKeys"
                   #certNos="ngModel" [required]="!formData.certificateOptional">
            <app-certificate-select
              [items]="formData.certificateOptions"
              [control]="certNos.control"
              (selectionChange)="formData.onCertificateSelectionChange($event)"
              size="sm">
            </app-certificate-select>
            @if (certNos.invalid && certNos.touched) {
              <div class="invalid-feedback d-block">กรุณาเลือกอย่างน้อย 1 ใบรับรอง</div>
            }
          </div>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-12">
            <label class="form-label" for="companyLegalName">ชื่อนิติบุคคล</label>
            <input
              id="companyLegalName"
              type="text"
              class="form-control form-control-sm"
              name="juristicName"
              [(ngModel)]="formData.model.juristicName"
              disabled
              placeholder="">
          </div>
        </div>

        <div class="row g-3 mb-3">
          <div class="col-12 col-md-6">
            <label class="form-label" for="juristicType">ประเภทนิติบุคคล</label>
            <input
              id="juristicType"
              type="text"
              class="form-control form-control-sm"
              name="juristicTypeLabel"
              [ngModel]="formData.selectedJuristicType?.title"
              disabled
              placeholder="">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label" for="juristicRegDate">วันที่จดทะเบียนจัดตั้ง</label>
            <input
              id="juristicRegDate"
              type="text"
              class="form-control form-control-sm"
              name="juristicRegDate"
              [ngModel]="(formData.model.juristicRegDate | thaidatetime: {showTime:false})"
              disabled>
          </div>
          <div class="col-12">
            <label class="form-label" for="juristicAuthorizedSignatory">ผู้มีอำนาจลงนาม</label>
            <textarea
              id="juristicAuthorizedSignatory"
              class="form-control form-control-sm"
              name="juristicAuthorizedSignatory"
              [(ngModel)]="formData.model.juristicAuthorizedSignatory"
              disabled></textarea>
          </div>
          <div class="col-12">
            <label class="form-label" for="juristicDirectors">กรรมการ / หุ้นส่วน</label>
            <textarea
              id="juristicDirectors"
              class="form-control form-control-sm"
              name="juristicDirectors"
              [(ngModel)]="formData.model.juristicDirectors"
              disabled></textarea>
          </div>
          <div class="col-12">
            <label class="form-label" for="juristicAddress">ที่อยู่</label>
            <textarea
              id="juristicAddress"
              type="text"
              class="form-control form-control-sm"
              name="juristicAddress"
              [(ngModel)]="formData.model.juristicAddress"
              disabled></textarea>
          </div>
        </div>

        <h6 class="form-group-heading">ข้อมูลธุรกิจ</h6>
        <div class="row g-3 mb-3">
          <div class="col-12 col-md-6">
            <label class="form-label" for="companyBusinessName">ชื่อธุรกิจ <span class="text-danger">*</span></label>
            <input id="companyBusinessName" type="text" class="form-control form-control-sm" name="title"
                   [(ngModel)]="formData.model.title" #titleRef="ngModel" required
                   [class.is-invalid]="titleRef.invalid && titleRef.touched">
            @if (titleRef.invalid && titleRef.touched) {
              <div class="invalid-feedback d-block">กรุณากรอกชื่อธุรกิจ</div>
            }
          </div>
          <div class="col-12">
            <label class="form-label">ประเภทธุรกิจ <span class="text-danger">*</span></label>
            <input type="hidden" name="businessTypeIds" [ngModel]="formData.selectedBusinessTypeIds"
                   #businessTypesRef="ngModel" required>
            <div class="business-type-groups">
              @for (group of formData.businessTypeGroups; track group.stage) {
                <div class="business-type-group">
                  <div class="business-type-group-title">
                    <span class="business-type-stage" [attr.data-stage]="group.stage">{{ group.label }}</span>
                    <small class="text-muted">{{ group.hint }}</small>
                  </div>
                  <div class="row row-cols-1 row-cols-md-2 g-1">
                    @for (option of group.types; track option.id) {
                      <div class="col">
                        <div class="form-check" [class.is-inactive]="!formData.isBusinessTypeActive(option)">
                          <input class="form-check-input" type="checkbox" [id]="'companyBusinessType' + option.id"
                                 [checked]="formData.isBusinessTypeSelected(option.id)"
                                 (change)="formData.toggleBusinessType(option.id, $any($event.target).checked)">
                          <label class="form-check-label" [for]="'companyBusinessType' + option.id">
                            {{ option.title }}
                            @if (!formData.isBusinessTypeActive(option)) {<span class="business-type-inactive">ปิดใช้งาน</span>}
                          </label>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            @if (businessTypesRef.invalid && businessTypesRef.touched) {
              <div class="invalid-feedback d-block">กรุณาเลือกประเภทธุรกิจอย่างน้อย 1 ประเภท</div>
            }
          </div>
          <div class="col-12">
            <label class="form-label" for="companyBusinessNameEn">ชื่อธุรกิจ (EN)</label>
            <input id="companyBusinessNameEn" type="text" class="form-control form-control-sm" name="titleEn"
                   [(ngModel)]="formData.model.titleEn">
          </div>
          <div class="col-12">
            <label class="form-label" for="companyBusinessDescription">รายละเอียดธุรกิจ</label>
            <textarea
              id="companyBusinessDescription"
              class="form-control form-control-sm"
              name="detail"
              [(ngModel)]="formData.model.detail"
              rows="4"
              placeholder="อธิบายสินค้า บริการ หรือรูปแบบธุรกิจโดยย่อ"></textarea>
          </div>
          <div class="col-12">
            <label class="form-label" for="companyRegistrationDocument">สำเนาหนังสือจดทะเบียนบริษัท หรือ
              หนังสือรับรองบริษัท</label>
            <app-file-upload
              inputId="companyRegistrationDocument"
              accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
              hint="ไฟล์ PDF, PNG, JPG ขนาดไม่เกิน 5 MB">
            </app-file-upload>
          </div>
        </div>

        <h6 class="form-group-heading">ที่อยู่</h6>
        <div class="row g-3 mb-3">
          <div class="col-12">
            <label class="form-label">เลขที่ <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-sm" name="hqAddressNo"
                   [(ngModel)]="formData.model.hqAddressNo"
                   [readonly]="formData.certificateOptions.length > 0 && !formData.companyManualAddress()">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">ตรอก/ซอย</label>
            <input type="text" class="form-control form-control-sm" name="hqSoi"
                   [(ngModel)]="formData.model.hqSoi">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">ถนน</label>
            <input type="text" class="form-control form-control-sm" name="hqStreet"
                   [(ngModel)]="formData.model.hqStreet">
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">ตำบล/แขวง <span class="text-danger">*</span></label>
            <app-subdistrict-autocomplete
              name="subDistrict"
              [ngModel]="formData.subDistrict"
              (ngModelChange)="formData.onSubDistrictChange($event)"
              #subdistrictRef="ngModel"
              [required]="true"
              size="sm">
            </app-subdistrict-autocomplete>
            @if (subdistrictRef.invalid && subdistrictRef.touched) {
              <div class="invalid-feedback d-block">กรุณาเลือกตำบล/แขวง</div>
            }
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">อำเภอ/เขต</label>
            <input type="text" class="form-control form-control-sm" name="districtName"
                   [(ngModel)]="formData.districtName" readonly disabled>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">จังหวัด</label>
            <input type="text" class="form-control form-control-sm" name="provinceName"
                   [(ngModel)]="formData.provinceName" readonly disabled>
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">รหัสไปรษณีย์</label>
            <input type="text" class="form-control form-control-sm" name="hqZipcode"
                   [(ngModel)]="formData.model.hqZipcode" maxlength="5" readonly disabled>
          </div>
          <div class="col-12">
            <label class="form-label">อีเมล <span class="text-danger">*</span></label>
            <input type="email" class="form-control form-control-sm" name="email"
                   [(ngModel)]="formData.model.email" #emailRef="ngModel" required
                   [class.is-invalid]="emailRef.invalid && emailRef.touched">
            @if (emailRef.invalid && emailRef.touched) {
              <div class="invalid-feedback d-block">กรุณากรอกอีเมล</div>
            }
          </div>
        </div>
        <h6 class="form-group-heading">ช่องทางติดต่อ</h6>
        <div class="row g-3 mb-3">
          <div class="col-12 col-md-6">
            <label class="form-label">โทรศัพท์ <span class="text-danger">*</span></label>
            <input type="tel" class="form-control form-control-sm" name="hqPhone"
                   [(ngModel)]="formData.model.hqPhone" #phoneRef="ngModel" required
                   [class.is-invalid]="phoneRef.invalid && phoneRef.touched">
            @if (phoneRef.invalid && phoneRef.touched) {
              <div class="invalid-feedback d-block">กรุณากรอกเบอร์โทรศัพท์</div>
            }
          </div>
          <div class="col-12 col-md-6">
            <label class="form-label">โทรศัพท์ (เพิ่มเติม)</label>
            <input type="tel" class="form-control form-control-sm" name="hqFax"
                   [(ngModel)]="formData.model.hqFax">
          </div>
          <div class="col-12">
            <label class="form-label">เว็บไซต์</label>
            <input type="text" class="form-control form-control-sm" name="webSite"
                   [(ngModel)]="formData.model.webSite">
          </div>
          <div class="col-12">
            <label class="form-label">
              ตำแหน่งบนแผนที่
              @if (formData.locationRequired) {<span class="text-danger">*</span> <span class="requirement-note">บังคับเพราะเลือก {{ formData.locationRequiredNote }}</span>} @else {<span class="text-secondary small fw-normal">(ไม่บังคับสำหรับประเภทที่เลือก)</span>}
            </label>
            <div class="d-flex gap-2 align-items-center">
              <input id="companyLatitude" type="text" class="form-control form-control-sm maxw-125px" name="latitude"
                     [(ngModel)]="formData.model.latitude" readonly placeholder="ละติจูด"
                     #latitudeRef="ngModel" [required]="formData.locationRequired"
                     [class.is-invalid]="latitudeRef.invalid && latitudeRef.touched">
              <input id="companyLongitude" type="text" class="form-control form-control-sm maxw-125px" name="longitude"
                     [(ngModel)]="formData.model.longitude" readonly placeholder="ลองจิจูด">
              <button class="btn btn-sm btn-outline-primary-accent d-inline-flex align-items-center gap-1 text-nowrap"
                      type="button" (click)="formData.openLocationPicker('company')">
                <i class="bi bi-geo-alt"></i>
                <span>เลือกแผนที่</span>
              </button>
            </div>
            @if (latitudeRef.invalid && latitudeRef.touched) {
              <div class="invalid-feedback d-block">กรุณาเลือกตำแหน่งบนแผนที่</div>
            }
            <div class="form-text">คลิก "เลือกแผนที่" เพื่อระบุตำแหน่งของธุรกิจบนแผนที่</div>
          </div>
        </div>

        <h6 class="form-group-heading">สถานะใช้งาน</h6>
        <div class="mb-3">
          <div class="form-check form-check-inline">
            <input class="form-check-input" id="companyStatusActive" type="radio" name="state"
                   [(ngModel)]="formData.isActive" [value]="true">
            <label class="form-check-label" for="companyStatusActive">ใช้งาน</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" id="companyStatusInactive" type="radio" name="state"
                   [(ngModel)]="formData.isActive" [value]="false">
            <label class="form-check-label" for="companyStatusInactive">ไม่ใช้งาน</label>
          </div>
        </div>
</ng-container>